module.exports = __webpack_public_path__ + "img/jib.6153dc7f.jpg";